import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './AuthContext';

const ProfilesContext = createContext(null);

export const ProfilesProvider = ({ children }) => {
  const { session } = useAuth();
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    if (!session) { setProfiles([]); return; }
    (async () => {
      const { data, error } = await supabase.from('profiles').select('id, email, name, role, is_active').order('name');
      if (error) console.error('ProfilesContext load:', error);
      else setProfiles(data || []);
    })();
  }, [session?.user?.id]);

  const getUserName = useCallback(
    (email) => profiles.find(p => p.email === email)?.name || email,
    [profiles]
  );

  return (
    <ProfilesContext.Provider value={{ profiles, getUserName }}>
      {children}
    </ProfilesContext.Provider>
  );
};

export const useProfiles = () => {
  const ctx = useContext(ProfilesContext);
  if (!ctx) throw new Error('useProfiles must be used within ProfilesProvider');
  return ctx;
};
